import { render, staticRenderFns } from "./ManagementPage.vue?vue&type=template&id=10e73dbe&scoped=true&"
import script from "./ManagementPage.vue?vue&type=script&lang=ts&"
export * from "./ManagementPage.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementPage.vue?vue&type=style&index=0&id=10e73dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e73dbe",
  null
  
)

export default component.exports